import * as Yup from 'yup';
import { conditionalRequired, getDefaultItemId } from 'src/components/formik-utils';

export const initialValues = (item) => {
  const myId = getDefaultItemId(item);
  if(0 < myId){
    const isRemoved = !item.courseName;
    return {
      isRemoved,
      id: myId,
      name: item.name ?? '',
      phone: item.phone ?? '',
      birthday: item.birthday ?? '',
      email: item.email ?? '',
      identityCard: item.identityCard ?? '',
      genderLabel: item.genderLabel ?? null,
      avatar: item.avatar ?? null,
      gender: item.gender ?? null,
      note: item.note ?? null,
      degreeName: item.degreeName ?? null,
      partnerName: item.partnerName ?? null,
      partnerContact: item.partnerContact ?? '',
      firstCode: item.firstCode ?? '',
    }
  }
  return {
    isRemoved: false,
    id: 0,
    name: '',
    phone: '',
    birthday: '',
    email: '',
    identityCard: '',
    genderLabel: null,
    avatar: null,
    gender: null,
    note: null,
    degreeName: null,
    partnerName: null,
    partnerContact: null,
    firstCode: '',
  }
};

export const handleSubmitted = async (
  values, apiChangeNote
) => {
  apiChangeNote(values);
};

// Tracking submitted
export const handleTrackingSubmitted = async (
  values, unusedStatusIds, apiCreate, apiUpdate, apiDelete
) => {
  let isUpdate = values.myId > 0;
  if(isUpdate){
    const isUnused = unusedStatusIds.length === 0 || unusedStatusIds.includes(values.statusField);
    if(isUnused){
      isUpdate = false;
    }
  }

  if(isUpdate){
    if(values.isVerified) await apiDelete(values);
    else await apiUpdate(values);
  }
  else await apiCreate(values);
};


// Course
export const validationCourseSchema = (myId) => {
  const isRequired = true;

  const schema = Yup.object({
    nameField: conditionalRequired(Yup.string(), 'Tên học viên không được trống', isRequired),
    phoneField: conditionalRequired(Yup.string(), 'Sđt phải có', isRequired)
  });
  return schema;
};
export const handleCourseSubmitted = async (
  values, item, 
  apiCreate, apiUpdate
) => {
  values.studentId = item.id;

  if(values.myId > 0){
    apiUpdate(values);
  }else{
    apiCreate(values);
  }

};
